export enum VolumeWindow {
  daily,
  weekly,
  monthly,
}
